import { FC, ReactNode } from 'react'
import styled from 'styled-components'
import { Text } from '@tuhi/components'

import { menuItemStyle, MenuItemLabel } from './positiveMenuItem'
import { contentColorStyle } from '@tuhi/components/src/redesign/buttons/button'

const Button = styled.button<{ $isCollapsed: boolean }>`
    ${menuItemStyle}

    background-color: transparent;

    &:hover {
        background-origin: border-box;
        background-clip: padding-box, border-box;
        background-image: ${(p) =>
            `linear-gradient(${p.theme.colors.lightRed}, ${p.theme.colors.lightRed}), linear-gradient(261.9deg, rgba(255, 218, 218, 0.4) 6.92%, rgba(233, 87, 87, 0.4) 146.46%)`};

        ${(p) => contentColorStyle(p.theme.colors.primaryRed)}
    }
`

interface Props {
    text: string
    icon: ReactNode
    onClick: () => void
    isCollapsed: boolean
}

export const NegativeMenuItem: FC<Props> = ({
    onClick,
    text,
    icon,
    isCollapsed,
}) => {
    const textContent = (
        <MenuItemLabel>
            <Text size="medium" $weight="medium" color="none">
                {text}
            </Text>
        </MenuItemLabel>
    )

    return (
        <Button onClick={onClick} $isCollapsed={isCollapsed}>
            {icon}
            {!isCollapsed ? textContent : <></>}
        </Button>
    )
}
